<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card>
      <v-card-title class="title">
        Tra cứu thông tin sim<span class="headline" v-if="dataSim && dataSim.phone">&nbsp;-&nbsp;{{ dataSim.phone }}</span>
        <v-spacer></v-spacer>
        <v-chip small color="green accent-3" text-color="white" v-if="dataSim && dataSim.isPrepaid">Trả trước</v-chip>
        <v-chip small color="teal" text-color="white" v-if="dataSim && !dataSim.isPrepaid">Trả sau</v-chip>
      </v-card-title>
      <v-card-text v-if="dataSim">
        <v-container fluid grid-list-md class="pa-0">
          <v-layout row justify-space-between>
            <v-flex xs6>
              <p>
                <span class="font-weight-bold">Số Seri Sim: </span>
                {{dataSim.imei}}
              </p>
              <p>
                <span class="font-weight-bold">Nhà Mạng: </span>
                {{dataSim.gsmName}}
              </p>
              <p>
                <span class="font-weight-bold">Loại Topup: </span>
                {{dataSim.topupPlanName}}
              </p>
              <p>
                <span class="font-weight-bold">Khách hàng: </span>
                {{dataSim.customerName}}
              </p>
            </v-flex>
            <v-flex xs6>
              <p>
                <span class="font-weight-bold">Bán: </span>
                {{dataSim.agencyName}}
              </p>
              <p>
                <span class="font-weight-bold">Số Phiếu Xuất: </span>
                {{dataSim.misaNote}}
              </p>
              <p>
                <span class="font-weight-bold">Ngày Xuất: </span>
                {{dataSim.saleDate | formatDate}}
              </p>
              <p>
                <span class="font-weight-bold">Ghi Chú: </span>
                <pre class="text-pre">{{dataSim.remark}}</pre>
              </p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text v-else>
       <i> Không có thông tin.</i>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">Đóng</v-btn>
      </v-card-actions>
      <div class="d-flex loading-dialog" v-if="loading">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
  filters: {
    formatDate (date) {
      if (!date) return date;
      return moment(new Date(date)).format('YYYY-MM-DD');
    }
  },

  data: () => ({
    dialog: false,
    dataSim: null,
    loading: false
  }),

  methods: {
    ...mapActions(['searchSim']),

    async open (simPhone) {
      this.dialog = true;
      this.loading = true;
      let res = await this.searchSim({ search: simPhone }).catch(err => {
        console.log('open -> err', err);
        return null;
      });
      this.loading = false;
      this.dataSim = res;
      console.log('this.dataSim', this.dataSim);
    },

    close () {
      this.dialog = false;
    }
  }
};
</script>

<style>
.text-pre{
  font-family: 'Roboto', sans-serif;
  white-space: break-spaces;
}
</style>
<style scoped>
.loading-dialog{
 position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.4);
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
}
.loading-dialog >>> .v-progress-circular{
  flex: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/vehicle/components/DialogSearchSim.vue